import { Card, CardCategories } from "@types"
import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface DarkPricingCardProps {
  cards: Card
  isSelectedCard?: boolean
  setSelectedCard?: Dispatch<SetStateAction<Card | undefined>>
  setShowQuote?: Dispatch<SetStateAction<boolean>>
}
export const DarkBluePricingCard = ({
  cards,
  setSelectedCard,
  setShowQuote,
  isSelectedCard,
}: DarkPricingCardProps) => {
  const [checkedItems, setCheckedItems] = React.useState(
    (cards.categories as CardCategories[]).map((category) =>
      (category?.list ?? []).map((item) => ({ ...item, isChecked: false }))
    )
  )

  const toggleCheckbox = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]
    updatedCheckedItems[categoryIndex][listIndex].isChecked =
      !updatedCheckedItems[categoryIndex][listIndex].isChecked
    setCheckedItems(updatedCheckedItems)
  }

  const toggleRadioOption = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]

    // Uncheck all items in the category
    updatedCheckedItems[categoryIndex] = updatedCheckedItems[categoryIndex].map(
      (item, i) => ({
        ...item,
        isChecked: i === listIndex, // Only the selected item is checked
      })
    )

    setCheckedItems(updatedCheckedItems)
  }

  const getSelectedCard = () => {
    const selectedCard = {
      ...cards,
      categories:
        cards.categories &&
        cards.categories.map((category, categoryIndex) => ({
          ...category,
          list:
            category.list &&
            category.list.map((item, listIndex) => ({
              ...item,
              isChecked: checkedItems[categoryIndex][listIndex].isChecked,
            })),
        })),
    }
    if (setSelectedCard) setSelectedCard(selectedCard)
  }
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div
        className={`bg-dark-blue-card bg-input py-4 shadow-lg rounded-lg col-span-6  ${theme == "glassy" ? "border border-white border-t-0" : theme === "light" ? "" : theme === "dark" ? "" : "border border-white border-t-0"}`}
      >
        <div className="flex rounded-2xl mx-auto bg-dark-blue bg-btn px-4 bg-glass max-w-[60%] w-fit">
          <div className="text-center w-full rounded-lg">
            <p
              className={` font-semibold text-nowrap text-sm p-2 ${theme == "glassy" ? "text-glass-white" : theme === "light" ? "text-[#7B68EC]" : theme === "dark" ? "text-[#7B68EC]" : "text-glass-white"}`}
            >
              {cards.cardTitle}
            </p>
          </div>
        </div>
        <div className="pt-8 px-4">
          <div className="px-2">
            <h3 className="text-6xl font-semibold text-glass-white text-center pt-5">
              {cards.cardPrice}
            </h3>
            <p
              className={` text-center pt-3 ${theme == "glassy" ? "text-yellow" : theme === "light" ? "text-[#7B68EC]" : theme === "dark" ? "text-[#7B68EC]" : "text-yellow"}`}
            >
              {cards.subtitle}
            </p>
            <p className="text-glass-white text-xl font-semibold text-center pt-3 px-4">
              {cards.description}
            </p>
          </div>
          <div className="flex justify-center pt-4">
            <hr className="w-4/6 opacity-30" />
          </div>

          {cards?.categories &&
            cards?.categories.map((category: CardCategories, index) => (
              <>
                <div
                  key={index}
                  className={`relative w-fit  ${
                    category.title === "Branding" ||
                    category.title === "Consulting Services" ||
                    category.title === "Our Technologies" ||
                    category.title?.includes("Recommended")
                      ? "mx-auto !w-[60%]"
                      : ""
                  }`}
                >
                  <div className="h-2"></div>
                  <p
                    className={`text-glass-white text-center pt-3 ${
                      category.title === "Branding" ||
                      category.title === "Consulting Services" ||
                      category.title === "Our Technologies" ||
                      category.title?.includes("Recommended") ||
                      category.title?.includes("UI/UX Design")
                        ? "text-lg font-semibold pt-5"
                        : `  ${theme == "glassy" ? "!text-[#FFFFFFCC]" : theme === "light" ? "text-[#7B68EC]" : theme === "dark" ? "text-[#7B68EC]" : "!text-[#FFFFFFCC]"}`
                    }`}
                  >
                    {category.title}{" "}
                    {category.alignment === "right" && (
                      <span
                        className={`text-xs  ${theme == "glassy" ? "text-yellow" : theme === "light" ? "text-[#7B68EC]" : theme === "dark" ? "text-[#7B68EC]" : "text-yellow"}`}
                      >
                        {category.titleSubDescription}
                      </span>
                    )}
                  </p>
                  {category.alignment === "bottom" && (
                    <div className="pt-1 text-center px-3">
                      <p
                        className={`text-xs ${theme == "glassy" ? "text-yellow" : theme === "light" ? "text-[#7B68EC]" : theme === "dark" ? "text-[#7B68EC]" : "text-yellow"}`}
                      >
                        {category.titleSubDescription}
                      </p>
                    </div>
                  )}
                </div>
                {category.list &&
                  category.type === "tick" &&
                  category?.list.map((list) => (
                    <div className="text-glass-white flex gap-2 items-center text-xs font-normal pt-2">
                      <div
                        className={` ${theme == "glassy" ? "stroke-white" : theme === "light" ? "stroke" : theme === "dark" ? "stroke" : "stroke-white"}`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="8"
                          viewBox="0 0 10 8"
                          fill="none"
                        >
                          <path
                            d="M1 4.2L3.66667 7L9 1"
                            stroke=""
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <p className="text-glass-white font-semibold">
                        {list.title}{" "}
                        <span
                          className={` text-[10px] ${theme == "glassy" ? "text-yellow" : theme === "light" ? "text-[#7B68EC]" : theme === "dark" ? "text-[#7B68EC]" : "text-yellow"}`}
                        >
                          {list.titleSubDescription}
                        </span>
                      </p>
                    </div>
                  ))}
                {category.list && category.type === "radioOptions" && (
                  <div className="text-glass-white grid-container pt-2 gap-2">
                    {category?.list.map((list, i) => (
                      <>
                        {isSelectedCard !== true ? (
                          <div
                            key={i}
                            className=" col-span-5 my-1 gap-2 flex items-center"
                          >
                            <div className="flex gap-2 items-center">
                              <div className="border border-white rounded-full flex items-center justify-center p-1 w-6 h-6">
                                <input
                                  className="input-radio-purple !w-3 !h-3"
                                  type="radio"
                                  id={list.title}
                                  value={list.title}
                                  name="darkBlueCard"
                                  checked={
                                    list.isChecked ||
                                    checkedItems[index][i].isChecked
                                  }
                                  onChange={() => toggleRadioOption(index, i)}
                                />
                              </div>
                              <label
                                className="text-glass-white text-xs"
                                htmlFor={list.title}
                              >
                                {list.title}
                              </label>
                            </div>
                          </div>
                        ) : (
                          <>
                            {list.isChecked && (
                              <div
                                key={i}
                                className=" col-span-5 my-1 gap-2 flex items-center"
                              >
                                <div className="flex gap-2 items-center">
                                  <div className="border border-white rounded-full flex items-center justify-center p-1 w-6 h-6">
                                    <input
                                      className="input-radio-purple !w-3 !h-3"
                                      type="radio"
                                      id={list.title}
                                      value={list.title}
                                      name="darkBlueCard"
                                      checked={
                                        list.isChecked ||
                                        checkedItems[index][i].isChecked
                                      }
                                      onChange={() =>
                                        toggleRadioOption(index, i)
                                      }
                                    />
                                  </div>
                                  <label
                                    className="text-glass-white text-xs"
                                    htmlFor={list.title}
                                  >
                                    {list.title}
                                  </label>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
                {category.list && category.type === "selectionOptions" && (
                  <div className="text-black flex flex-wrap gap-2 px-2 pt-2 gap-2">
                    {category?.list.map((list, i) => (
                      <>
                        {isSelectedCard !== true ? (
                          <div
                            key={i}
                            className=" my-1 gap-1 flex items-center"
                          >
                            <div
                              onClick={() => toggleCheckbox(index, i)}
                              className="checkbox cursor-pointer rounded-[5px] radio-btns-border w-4 h-4"
                            >
                              {(checkedItems[index][i].isChecked ||
                                list.isChecked) && (
                                <div className="checked bg-[#7B68EC] rounded-[5px] h-full w-full text-center text-white">
                                  <div className="stroke-white flex items-center justify-center rounded-[5px]">
                                    <svg
                                      className="mt-1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="10"
                                      height="8"
                                      viewBox="0 0 10 8"
                                      fill="none"
                                    >
                                      <path
                                        d="M1 4.2L3.66667 7L9 1"
                                        stroke=""
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              )}
                            </div>
                            <p className="text-glass-white text-xs">
                              {list.title}
                            </p>
                          </div>
                        ) : (
                          <>
                            {list.isChecked && (
                              <div
                                key={i}
                                className=" col-span-8 my-1 gap-2 flex items-center"
                              >
                                <div
                                  onClick={() => toggleCheckbox(index, i)}
                                  className="checkbox cursor-pointer border border-black w-6 h-6"
                                >
                                  {(checkedItems[index][i].isChecked ||
                                    list.isChecked) && (
                                    <div className="checked bg-[#7B68EC] h-full w-full text-center text-white">
                                      ✓
                                    </div>
                                  )}
                                </div>
                                <p className="text-black text-xs">
                                  {list.title}
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
              </>
            ))}
          <div>
            <p className="text-glass-white text-xs text-center font-semibold py-12">
              {cards.footerDescription}{" "}
              <span className="text-yellow">{cards.footerSubDescription}</span>
            </p>
          </div>
          <div className="pt-4">
            {isSelectedCard !== true && (
              <button
                onClick={() => {
                  getSelectedCard()
                  setShowQuote && setShowQuote(true)
                }}
                className="border border-white font-semibold bg-btn text-sm py-3 text-glass-white w-full p-2 rounded-3xl"
              >
                Download Selection & Book Your Slot
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
